module.exports = __webpack_public_path__ + "img/home_view_pager_002.078bfa48.png";